module.exports = __webpack_public_path__ + "img/saint-kitts-and-nevis.a99d0f9b.svg";